export default __webpack_public_path__ + "static/media/Asset1_MainBannerOffroad.427254b8.jpeg";